import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';

const PreviewTaskFromTemplate = graphql(`
  query PreviewTaskFromTemplate($input: PreviewTaskFromTemplateInput!) {
    previewTaskFromTemplate(input: $input) {
      __typename
      ... on ITaskFromTemplatePreview {
        name
        notes
        assignedTo {
          __typename
          ... on User {
            publicId
          }
          ... on Team {
            id
          }
        }
        deadlineDate
      }
      ... on ChecklistTaskFromTemplatePreview {
        checklistItems
      }
      ... on FormTaskFromTemplatePreview {
        formTemplate {
          id
        }
      }
      ... on LegacyFormTaskFromTemplatePreview {
        formTemplate {
          id
        }
      }
    }
  }
`);

/**
 * What a task created from a template on a project would look like, with the
 * template's assignee / deadline resolved server-side. Backs the arrange-task
 * form prefill.
 */
const useGetTaskFromTemplatePreview = (args: {
  templateId?: string;
  projectId?: string;
}) => {
  const { templateId, projectId } = args;

  const { data, ...rest } = useQuery({
    queryKey: ['taskFromTemplatePreview', templateId, projectId],
    enabled: !!templateId && !!projectId,
    meta: { errorMessage: 'Could not load the task template' },
    queryFn: () =>
      gqlClient.request(PreviewTaskFromTemplate, {
        input: { templateId: templateId!, projectId: projectId! },
      }),
  });

  return { preview: data?.previewTaskFromTemplate, ...rest };
};

export default useGetTaskFromTemplatePreview;
